module.exports = __webpack_public_path__ + "static/img/diagram.4e741eb6.png";